module.exports = __webpack_public_path__ + "img/product2.67b27134.jpg";